import gql from 'graphql-tag';

export class DocumentsFragments {
  static tagFragment = gql`
    fragment tagFragment on Tag {
      title
      status
      id
    }
  `;

  static documentsUserFragment = gql`
    fragment documentsUserFragment on User {
      id
      fullName
      thumbUrl
      email
      imageScale
      imageTranslateX
      imageTranslateY
    }
  `;

  static documentsRecipientFragment = gql`
    fragment documentsRecipientFragment on Recipient {
      id
      companyName
      fullName
      thumbUrl
      email
    }
  `;

  static documentsListFragment = gql`
    fragment documentsListFragment on DocumentDto {
      id
      name
      companyName
      status
      value
      expirationDate
      tags {
        ...tagFragment
      }
      user {
        ...documentsUserFragment
      }
      recipients {
        ...documentsRecipientFragment
      }
      type
      signDate
      createdAt
      isPrivate
      isSmsReminder
      isReminderSending
      reminderRepeat
      reminderOpened
      reminderSigned
      reminderExpiration
      reminderOpenedDays
      reminderSignedDays
      reminderRepeatDays
      reminderExpirationDays
    }
    ${DocumentsFragments.tagFragment}
    ${DocumentsFragments.documentsUserFragment}
    ${DocumentsFragments.documentsRecipientFragment}
  `;
}
